import { createStore, createEvent } from 'effector';

export enum NotificationType {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
}

interface INotification {
  type: NotificationType;
  message: string | null | undefined;
}

const setErrorEvent = createEvent<string | null | undefined>();
const setSuccessEvent = createEvent<string | null | undefined>();
const setWarningEvent = createEvent<string | null | undefined>();
const clearEvent = createEvent();

const $errorStore = createStore<INotification | null>(null)
  .on(setErrorEvent, (_, message) => (message ? { type: NotificationType.ERROR, message } : null))
  .on(setSuccessEvent, (_, message) => (message ? { type: NotificationType.SUCCESS, message } : null))
  .on(setWarningEvent, (_, message) => (message ? { type: NotificationType.WARNING, message } : null))
  .reset(clearEvent);

let timeoutId: NodeJS.Timeout | null = null;
$errorStore.watch((notification) => {
  if (!notification?.message) return;

  if (timeoutId) clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    clearEvent();
    timeoutId = null;
  }, 10000); // every 10 sec
});

export const $notificationStore = {
  events: {
    setError: setErrorEvent,
    setSuccess: setSuccessEvent,
    setWarning: setWarningEvent,
    clear: clearEvent,
  },
  store: $errorStore,
};
